// React
import React from 'react';
import { Typography } from '@material-ui/core';
// componentes
import { useStyles } from "./style";
import DialogInformation from 'components/DialogAlert'

export default function ComponenteInformeDeCierrePadronDelegados (props) {
    const classes = useStyles();
    
    return (
        <DialogInformation
            open={props.open}
            closeModal={props.closeModal}
            titleToolbar="Observaciones"
            fullWidth={true}
            maxWidth={'md'}
        >
            <Typography className={classes.marginText} variant="body2" gutterBottom>{props.observacion}</Typography>
        </DialogInformation>
    )
}